module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--10.05ecaf64.png";